import { useTranslations } from "next-intl";
import { getTranslations } from "next-intl/server";
import type { TagsFiltersSetup } from "@/features/filters/types/filters-setup.type";
import type { TagsResponse } from "@/features/filters/types/tags.type";
import type { DietCatalogTagsType } from "../types";

export type SerializedTag =
  | (DietCatalogTagsType & {
      label: string;
    })
  | (TagsFiltersSetup & {
      label: string;
    });

export const serializeTags = async (
  tags: DietCatalogTagsType[] | TagsResponse[] | TagsFiltersSetup[],
): Promise<SerializedTag[]> => {
  const t = await getTranslations();
  return tags.map((tag) => ({
    ...tag,
    label: t(`dietTags.${tag.slug}`),
  }));
};

export const serializeTagsClient = (
  tags?: DietCatalogTagsType[] | TagsResponse[] | TagsFiltersSetup[],
): SerializedTag[] | undefined => {
  const t = useTranslations();
  return tags?.map((tag) => ({
    ...tag,
    label: t(`dietTags.${tag.slug}`),
  }));
};
